import type { Profile } from 'app-components/flux/profile/profileTypes';

import type { Dataset } from './datasetsTypes';

export const hasActiveEntitlement = (dataset: Dataset) =>
  dataset.entitlements?.find((entitlement) => entitlement.id?.startsWith('ACME_') && entitlement.active);

// Shared space whose entitlements loaded with none active, e.g. the owner's subscription lapsed.
export const isUnavailableShare = (dataset: Dataset) =>
  Boolean(dataset.shared && dataset.entitlements && !hasActiveEntitlement(dataset));

export const makeQEMDatasetNameFromProfile = (profile: Profile | undefined | null) => {
  const profileName = profile?.lastName || profile?.firstName;
  return `${profileName ? `${profileName}'s` : 'My'} Household`;
};

export const defaultQEMDatasetName = (currentName: string, profile: Profile) => {
  if (currentName?.indexOf('Finances') === -1 && currentName?.indexOf('My Household') === -1) {
    // doesn't have default 'Finances' or 'My Household'
    return currentName;
  }
  return makeQEMDatasetNameFromProfile(profile);
};
